import { Storage } from "aws-amplify";
import { NEXPYN_BUCKET, REGION } from "../../common/constants";
import { UploadFile } from "./type";
import onHandleCompressImages from "./image-compression/component";

export const onHandleS3Upload = async (id: number | string, version: string, listOfFiles: UploadFile[]) => {
    Storage.configure({
        bucket: NEXPYN_BUCKET,
        region: REGION,
        customPrefix: {
            public: `${id}/${version}/`
        }
    });
    try {
        const compressedFileList = await onHandleCompressImages(listOfFiles);
        await Promise.all(compressedFileList.map(async (file: any) => {
            await Storage.put(
                file.name,
                file,
                { contentType: file.type }
            );
        }));
        return { status: "Success", message: "Files uploaded successfully." };
    } catch (error) {
        console.error("Upload error:", error);
        return { status: "Failure", message: "File upload failed. Please try again." };
    }
};

export const onHandleS3Delete = async (id: number | string,version: string,fileName: string) => {
    Storage.configure({
        bucket: NEXPYN_BUCKET,
        region: REGION,
        customPrefix: {
            public: `${id}/${version}/`,
        },
    });
    try {
        await Storage.remove(fileName);
        return { status: "Success", message: "File deleted successfully." };
    } catch (error) {
        return { status: "Failure", message: "File deletion failed. Please try again." };
    }
};
